module.exports = __webpack_public_path__ + "static/media/debank.db43c06d.svg";